import * as TYPES from "./types";
import { getMuseumEvents } from "@/api/museums";

const state = () => ({
  // from data
  events: null,
  // from back
  shows: null,
});

const actions = {
  async [TYPES.FETCH_EVENTS]({ commit }, payload) {
    await getMuseumEvents(payload)
      .then((resp) => commit(TYPES.SET_EVENTS, resp))
      .catch((err) => console.log(err));
  },
};

const mutations = {
  [TYPES.GET_EVENTS](state, payload) {
    const events = require(`@/../data/${payload}/events.json`);
    state.events = events;
  },
  [TYPES.SET_EVENTS](state, payload) {
    state.shows = payload;
  },
};

const getters = {
  museumEvents: (state) => state.events,
  fetchEvents: (state) => state.shows,
};

export default {
  actions,
  state,
  mutations,
  getters,
};
